import { DEPT_NORMAL, DEPT_MINISTER, BUREAU_MANAGE, DEPT_LEADER } from "../utils/utilData";
import { subArray } from "../utils/utilApi"
let events = [
  {
    id: 1,
    name: "【季度工作报告制定】提醒",
    url: "/department-task-make",
  },
  {
    id: 1,
    name: "【季度工作报告审核】提醒",
    url: "/task-plan-review",
  },
  {
    id: 2,
    name: "【考核成绩公示】提醒",
    url: "/eva-result-display",
  },
  {
    id: 3,
    name: "【季度考核评分】提醒",
    url: "/eva-events",
  }
]

let personalTaskTable = [
  {
    label: "姓名",
    prop: "name",
  },
  {
    label: "任务总数",
    prop: "taskNum",
  },
  {
    label: "已完成",
    prop: "accomplishNum",
  },
  {
    label: "未完成",
    prop: "unaccomplishNum",
  },
  {
    label: "完成率(%)",
    prop: "accomplishRate",
  },
]

let employeeScoreTable = [
  {
    label: "姓名",
    prop: "name",
  },
  {
    label: "综合得分",
    prop: "totalScore",
  },
  {
    label: "考评等次",
    prop: "rate",
  },
]

let deptTaskTable = [
  {
    label: "科室",
    prop: "departmentName",
  },
  {
    label: "任务总数",
    prop: "taskNum",
  },
  {
    label: "已完成",
    prop: "accomplishNum",
  },
  {
    label: "未完成",
    prop: "unaccomplishNum",
  },
  {
    label: "完成率(%)",
    prop: "accomplishRate",
  },
]

let deptScoreTable = [
  {
    label: "科室",
    prop: "departmentName",
  },
  {
    label: "综合得分",
    prop: "totalScore",
  },
  {
    label: "考评等次",
    prop: "rate",
  },
]

let resourceList = [
  { id: 10000, name: '工作任务管理', url: '10000' },
  { id: 10001, name: '科室工作任务制定', url: 'department-task-make', icon: 'deptbehav' },
  { id: 10003, name: '工作任务审批', url: 'task-plan-review', icon: 'behavview' },
  { id: 10004, name: '任务接受', url: 'task-accept', icon: '' },
  { id: 10005, name: '个人工作任务制定', url: 'personal-task-make', icon: 'persbehav' },
  { id: 10006, name: '关键任务管理', url: 'key-task-manage' },
  { id: 20000, name: '工作报告管理', url: '20000' },
  { id: 20001, name: '个人工作小结报告', url: 'personal-report' },
  { id: 20002, name: '个人工作小结审批', url: 'personal-report-review' },
  { id: 20003, name: '科室工作小结报告', url: 'department-report' },
  { id: 20004, name: '科室工作小结审批', url: 'department-report-review' },
  { id: 30000, name: '考核评鉴管理', url: '30000' },
  { id: 30001, name: '考核评定待办', url: 'eva-events', icon: 'evaevent' },
  { id: 30002, name: '*考核情况跟踪', url: '30002' },
  { id: 30003, name: '*考核结果查询', url: '30003' },
  { id: 30004, name: '考核成绩公示', url: 'eva-result-display', icon: 'evares' },
  { id: 40000, name: '指标库管理', url: '40000' },
  { id: 40001, name: '动态指标管理', url: 'norm-manage', icon: 'norm' },
  { id: 40002, name: '*加减分项目管理', url: '40002' },
  { id: 40003, name: '*加减分记录查询', url: '40003' },
  { id: 50000, name: '系统配置管理', url: '50000' },
  { id: 50001, name: '*系统参数配置', url: '50001' },
  { id: 50002, name: '考核模型配置', url: 'eva-model', icon: 'model' },
  { id: 50003, name: '评等配置', url: 'rate-manage', icon: 'rate' },
  { id: 60000, name: '人事管理', url: '60000' },
  { id: 60001, name: '人员信息管理', url: 'employee-manage', icon: 'person' },
  { id: 60002, name: '科室部门人员管理', url: 'bureau-manage', icon: 'dept' },
  { id: 60003, name: '内设部门机构管理', url: 'department-manage', icon: 'dept' },
  { id: 60004, name: '*人员类别管理', url: '60004' },
  { id: 60005, name: '考勤管理', url: 'attendance-manage', icon: 'attend' },
  { id: 60006, name: '加减分情况管理', url: 'as-item' },
]

let commonEvaEmployeeTable = [
  { label: "用户ID", prop: "userId" },
  { label: "用户姓名", prop: "username" },
  { label: "是否考评完成", prop: "evaluate", sortable: true },
]

let commonEvaDeptTable = [
  { label: "科室名称", prop: "departmentName" },
  { label: "考评完成人数", prop: "commonEvaComp", sortable: true },
  { label: "未完成人数", prop: "commonEvaUncomp", sortable: true },
  { label: "完成率(%)", prop: "proportion", sortable: true },
]

let weekSummaryTable = [
  { label: "科室名称", prop: "departmentName" },
  { label: "姓名", prop: "userName", sortable: true },
  { label: "第一季度（篇）", prop: "season1", sortable: true },
  { label: "第二季度（篇）", prop: "season2", sortable: true },
  { label: "第三季度（篇）", prop: "season3", sortable: true },
  { label: "第四季度（篇）", prop: "season4", sortable: true },
]

export { events, personalTaskTable, employeeScoreTable, deptTaskTable, deptScoreTable, resourceList, commonEvaEmployeeTable, commonEvaDeptTable, weekSummaryTable };

// 103: 0
export function getShortEntrance(roleId) {
  let res = [];
  switch (roleId) {
    case DEPT_NORMAL:
      res = subArray(resourceList, [4, 12]);
      break;
    case DEPT_MINISTER:
      res = subArray(resourceList, [1, 2, 4, 12, 29]);
      break;
    case BUREAU_MANAGE:
      res = subArray(resourceList, [15, 17, 22, 23, 25, 27, 29]);
      break;
    case DEPT_LEADER:
      res = subArray(resourceList, [2, 12]);
      break;
  }
  return res;
}